import DialogFormBooleanConfig from '~/components/dialog/form/DialogFormBooleanConfig.vue';

export const useDialogFormBooleanConfig = (
  config: any = null,
  model: Ref<boolean>
) => {
  const dialog = useDialogStore();
  const available = computed(() => config !== null);
  const open = () => {
    if (!available.value) return;
    dialog.open(DialogFormBooleanConfig, {
      level: DialogLevel.Info,
      config,
      title: config.title,
      label: config.text,
      cancel: true,
      buttonCancel: config.textCancel,
      buttonConfirm: config.textOk,
      align: 'center',
      onConfirm: () => {
        model.value = true;
        dialog.close();
      },
      onCancel: () => {
        model.value = false;
        dialog.close();
      },
    });
  };

  return {
    available,
    open,
  };
};
